// extracted by mini-css-extract-plugin
export default {"confirmation":"Confirmation_confirmation__-8hgg","buttons":"Confirmation_buttons__-40hF","changeBookingButton":"Confirmation_changeBookingButton__1-QHS"};